<template>
  <div class="note-box bg-skin-secondary">
    <div class="note-text text-skin-secondary">
      {{ item.content }}
    </div>
    <div class="interaction">
      <div class="play-minute "><span class="triangulo"></span> {{ item.time }}</div>
      <div class="actions-interaction">
        <button class="edit opacity-25 transition duration-300 hover:opacity-100"
        :class="{'opacity-50':this.GET_LOADDING}"
        @click.prevent.stop="editNote"
        :disabled="this.GET_LOADDING">
          <Edit 
            class="cursor-pointer"
            width="20px"
            height="20px"
          />
        </button>
        <button class="delete opacity-25 transition duration-300 hover:opacity-100"
        :class="{'opacity-50':this.GET_LOADDING}"
        @click.prevent.stop="deleteNote"
        :disabled="this.GET_LOADDING">
          <Delete 
            class="cursor-pointer"
            width="20px"
            height="20px"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from "./icons/Edit.vue";
import Delete from "./icons/Delete.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Edit,
    Delete
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("notes", ["GET_LOADDING"]),
  },
  methods: {
    editNote() {
      if(!this.GET_LOADDING){
        this.$store.commit("notes/SET_NOTE_EDIT", true);
        this.$store.commit("notes/SET_NOTE_SELECTED", this.item);
        this.$emit("change");
      }
    },
    deleteNote() {
      if(!this.GET_LOADDING){
        this.$store.dispatch("notes/delete_notes_course", {
          _note_id: this.item.id,
        });
      }
    },
  },
};
</script>

<style scoped>
.actions-interaction {
  display: flex;
  width: 20%;
  justify-content: space-between;
}

.play-minute {
  width: 80px;
  background: #e3e3e3 0% 0% no-repeat padding-box;
  border: 1px solid #e3e3e3;
  border-radius: 13px;
  text-align: center;
  font: normal normal normal 13px/15px Roboto;
  letter-spacing: 0px;
  opacity: 1;
  height: 25px;
  line-height: 1.7;
}

.triangulo {
    border-left: 12px solid #F28062;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    position: absolute;
    margin-left: -15px;
    margin-top: 4px;
}

.interaction {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
}

.note-box {
  width: 100%;
  height: 127px;
  box-shadow: 1px 2px 5px #00000029;
  border-radius: 7px;
  opacity: 1;
  padding: 17px 13px 13px 17px;
  margin-top: 20px;
}

.note-text {
  text-align: left;
  font: normal normal normal 13px/18px Roboto;
  letter-spacing: 0px;
  opacity: 1;
  border-bottom: 0.5px solid #cccccc;
  padding-bottom: 20px;
}
</style>
